<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
defineOptions({
  name: "App",
});
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
</style>
